import { Injectable, inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateShipmentFormGroup } from './create-shipment-form-group.interface';
import { CreateShipmentLineFormGroup } from './create-shipment-line-form-group.interface';
import { CreateShipmentLineDefaults, CreateShipmentLineFormModel } from './create-shipment-line-form.model';

@Injectable()
export class CreateShipmentFormModel {
  private readonly formBuilder = inject(FormBuilder);

  public readonly fieldNames = {
    shipmentDate: 'shipmentDate',
    lines: 'lines',
  } as const;

  public readonly form: FormGroup<CreateShipmentFormGroup>;

  constructor() {
    const formBuilder = this.formBuilder;

    this.form = formBuilder.group<CreateShipmentFormGroup>({
      shipmentDate: new FormControl<string | null>(null, { validators: [Validators.required] }),
      lines: formBuilder.array<FormGroup<CreateShipmentLineFormGroup>>([]),
    });
  }

  public get lines(): FormArray<FormGroup<CreateShipmentLineFormGroup>> {
    return this.form.controls.lines;
  }

  public addLine(defaults: CreateShipmentLineDefaults): FormGroup<CreateShipmentLineFormGroup> {
    const lineForm = CreateShipmentLineFormModel.buildFormGroup(this.formBuilder, defaults);
    this.lines.push(lineForm);
    return lineForm;
  }

  public clearLines(): void {
    while (this.lines.length > 0) {
      this.lines.removeAt(0);
    }
  }
}
